import { Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@apollo/client";

import { DELETE_OPTION } from "../../../graphql/mutations/management";
import { EditIcon, TrashIcon } from "../../../constants/icon_path";
import { setUpdateOption, toggleOptionModal } from "../redux/betOptionSlice";
import SimpleModal from "../../../components/common/SimpleModal";
import { GET_BET_OPTION_LIST } from "../../../graphql/queries/asset";
import OptionForm from "./form/OptionForm";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/common/CustomErrorMessage";

const OptionTable = ({ data, betOptionId }) => {
  const dispatch = useDispatch();
  const { isOpenOptionModal } = useSelector((state) => state.betOption);

  const handleEdit = (data) => {
    dispatch(
      setUpdateOption({
        id: data.id,
        name: data.name,
        engName: data.engName,
        profit: data.profit,
        isHaveProfit: data?.isHaveProfit,
      }),
    );
    dispatch(toggleOptionModal());
  };

  const [deleteOption] = useMutation(DELETE_OPTION, {
    refetchQueries: [{ query: GET_BET_OPTION_LIST }],
    onCompleted: (data) => {
      if (data.deleteOption) {
        showSuccessToast();
      }
    },
    onError(error) {
      showErrorToast(error.message);
    },
  });

  const handleClose = (shouldClear = false) =>
    dispatch(toggleOptionModal(shouldClear));

  const handleDelete = (data) => {
    const answer = window.confirm("ຕ້ອງການລຶບບໍ?");
    if (answer) {
      deleteOption({ variables: { id: data.id, betOptionId } });
    }
  };

  return (
    <>
      <SimpleModal show={isOpenOptionModal} handleClose={handleClose}>
        <OptionForm handleClose={handleClose} />
      </SimpleModal>
      <Table bordered responsive>
        <thead>
          <tr>
            <th className="text-center">
              <strong>#</strong>
            </th>
            <th className="text-center">
              <strong>ຊື່</strong>
            </th>
            <th className="text-center">
              <strong>ຊື່ພາສາອັງກິດ</strong>
            </th>
            <th className="text-center">
              <strong>ກຳໄລ່</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((d, i) => {
            return (
              <tr key={d.id}>
                <td className="text-center">
                  <strong>{i + 1}</strong>
                </td>
                <td className="text-center content">{d.name}</td>
                <td className="text-center content"> {d.engName}</td>
                <td className="text-center">{d.profit}</td>
                <td className="text-center d-flex">
                  <EditIcon
                    size={25}
                    color="green"
                    onClick={() => handleEdit(d)}
                    style={{ cursor: "pointer" }}
                  />
                  <TrashIcon
                    size={25}
                    color="red"
                    onClick={() => handleDelete(d)}
                    style={{ cursor: "pointer" }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default OptionTable;
